// extracted by mini-css-extract-plugin
export default {"heading-primary":"Checkbox_heading-primary__vmgXH","checkbox-input":"Checkbox_checkbox-input__u7CjW","checkbox-input--checked":"Checkbox_checkbox-input--checked__99K1u"};